export const TREE_FILTER_SPINNER_SHOW = 'TREE_FILTER_SPINNER_SHOW';

export const showQueryFormSpinner = () => ({
  type: TREE_FILTER_SPINNER_SHOW
});
